import type { UserResponse } from './UserResponse';
import type { UserRequest } from './UserRequest';

export class UserListItem {
  userId: number;
  userName: string;
  email: string;
  clientId: number | null;
  clientName: string;
  employeeId: number | null;
  employeeName: string;
  roleId: number;
  roleName: string;
  canViewAllEntries: boolean;
  isActive: boolean;
  createdDate: Date;
  modifiedDate: Date;
  createdBy: string;
  modifiedBy: string;

  constructor(response: UserResponse) {
    this.userId = response.userId;
    this.userName = response.userName;
    this.email = response.email;
    this.clientId = response.clientId;
    this.clientName = response.clientName;
    this.employeeId = response.employeeId;
    this.employeeName = response.employeeName;
    this.roleId = response.roleId;
    this.roleName = response.roleName;
    this.canViewAllEntries = response.canViewAllEntries;
    this.isActive = response.isActive;
    this.createdDate = new Date(response.createdDate);
    this.modifiedDate = new Date(response.modifiedDate);
    this.createdBy = response.createdBy;
    this.modifiedBy = response.modifiedBy;
  }

  toRequest(): UserRequest {
    return {
      userId: this.userId,
      userName: this.userName,
      email: this.email,
      roleId: this.roleId,
      canViewAllEntries: this.canViewAllEntries,
      isActive: this.isActive
    };
  }

  get relatedType(): 'employee' | 'client' | 'none' {
    if (this.employeeId) return 'employee';
    if (this.clientId) return 'client';
    return 'none';
  }

  get relatedName(): string {
    if (this.employeeId) return this.employeeName;
    if (this.clientId) return this.clientName;
    return '';
  }
}
